export const PI = Math.PI
const A = 6378245.0
const EE = 0.00669342162296594323

const outOfChina = (gcLng, gcLat) => gcLng < 72.004 || gcLng > 137.8347 || gcLat < 0.8293 || gcLat > 55.8271

const transformLng = (x, y) => {
  let ret = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x))
  ret += (20.0 * Math.sin(6.0 * x * PI) + 20.0 * Math.sin(2.0 * x * PI)) * 2.0 / 3.0
  ret += (20.0 * Math.sin(x * PI) + 40.0 * Math.sin(x / 3.0 * PI)) * 2.0 / 3.0
  ret += (150.0 * Math.sin(x / 12.0 * PI) + 300.0 * Math.sin(x / 30.0 * PI)) * 2.0 / 3.0
  return ret
}

const transformLat = (x, y) => {
  let ret = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x))
  ret += (20.0 * Math.sin(6.0 * x * PI) + 20.0 * Math.sin(2.0 * x * PI)) * 2.0 / 3.0
  ret += (20.0 * Math.sin(y * PI) + 40.0 * Math.sin(y / 3.0 * PI)) * 2.0 / 3.0
  ret += (160.0 * Math.sin(y / 12.0 * PI) + 320 * Math.sin(y * PI / 30.0)) * 2.0 / 3.0
  return ret
}

const delta = (gcLng, gcLat) => {
  let x = gcLng - 105.0
  let y = gcLat - 35.0
  let dLng = transformLng(x, y)
  let dLat = transformLat(x, y)
  let radLat = gcLat / 180.0 * PI
  let magic = Math.sin(radLat)
  magic = 1 - EE * magic * magic
  let sqrtMagic = Math.sqrt(magic)
  dLat = (dLat * 180.0) / ((A * (1 - EE)) / (magic * sqrtMagic) * PI)
  dLng = (dLng * 180.0) / (A / sqrtMagic * Math.cos(radLat) * PI)
  return {lng: dLng, lat: dLat}
}

export default (gcLng, gcLat) => {
  if (outOfChina(gcLng, gcLat)) {
    return {lng: gcLng, lat: gcLat}
  }

  let d = delta(gcLng, gcLat)

  return {
    lng: gcLng - d.lng,
    lat: gcLat - d.lat
  }
}



// WEBPACK FOOTER //
// ./src/components/Map/GCJ02ToWGS84.js